/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PaginationInputs */

const he_common_pagination = /** @type {(inputs: Common_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עימוד`)
};

const en_common_pagination = /** @type {(inputs: Common_PaginationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pagination`)
};

/**
* | output |
* | --- |
* | "pagination" |
*
* @param {Common_PaginationInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_pagination = /** @type {((inputs?: Common_PaginationInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PaginationInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_pagination(inputs)
	return en_common_pagination(inputs)
});